<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 33"
  >
    <path
      d="M24.75,19.26l-8.25-8.25-8.25,8.25,1.94,1.94,6.31-6.3,6.31,6.3,1.94-1.94Z"
    />
  </svg>
</template>